// Entry bootstrap. Deliberately tiny: its ONLY job is to pull in the real
// application module.
//
// Why the indirection: Rollup makes the build `input` (this file) the host for
// all code shared across lazy route chunks — it hoists shared modules here and
// has every route chunk `import { ... } from "./app.js"`. But the app is loaded
// in HTML under a phx.digest-hashed URL (`app-<md5>.js`) while the chunks still
// import the un-hashed `./app.js`; digest rewrites the HTML <script> but not the
// import specifiers inside chunks. Those are two different URLs for the same
// module, so the browser evaluates the entry TWICE — running the render
// side-effect (createRoot().render()) twice and remounting the whole app (the
// "flash to white and back" on staging).
//
// By keeping this entry side-effect-only and export-free, the shared code +
// render logic live in `./main`, which Rollup emits as a normally-hashed chunk
// that every consumer (HTML and route chunks) references by the SAME URL. The
// entry is imported by nobody, so it evaluates exactly once.
import('./main');
